import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

type LanguageCode = 'pt-br' | 'en' | 'es';

interface ILanguage {
  code: LanguageCode;
  name: string;
  flag: string; // Caminho para a imagem da bandeira
}

const flagsPath = 'assets/images/flags'

@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss'],
    imports: [CommonModule, FormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule]
})
export class LanguageSelectorComponent {
  languages: ILanguage[] = [
    { code: 'pt-br', name: 'Português', flag: `${flagsPath}/br.svg` },
  ];

  dropdownOpen = false;
  selectedLanguageCode: LanguageCode = 'pt-br';

  constructor(private elementRef: ElementRef){}

  get selectedLanguage() {
    return this.languages.find(lang => lang.code === this.selectedLanguageCode);
  }

  changeLanguage(value: LanguageCode) {
    this.selectedLanguageCode = value;
    this.toggleDropdown();
  }

  getSelectedFlagUrl(): string {
    return  this.selectedLanguage.flag;
  }

  getSelectedLanguageName(): string {
    return  this.selectedLanguage.name;
  }

  getSelectedLanguageCode(): string {
    return  this.selectedLanguage.code.slice(-2).toUpperCase();
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
    }
  }
}
